/**
 * @type {Array<{ path?: string, exact?: boolean, component: any }>}
 */
const routes = require(
  `${process.env.RAZZLE_ROOT_APP_PATH}/src/routes.js`,
).default;
// This base url is required to enable branch support. i.e
// For master: inspection/basic/29843983271983721/thank-you
// For branches: inspection/basic/__CFE-999/29843983271983721/thank-you

module.exports = routes;
